import { ILoginResponse } from '@inshuwa-client/models';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UmamiService } from '../services/umami.service';
import { sessionStore } from './session-store';

export function getStoredLoginResponse(): ILoginResponse | null {
  const token = sessionStore.getItem('token');

  return token ? (JSON.parse(token) as ILoginResponse) : null;
}

export function setStoredLoginResponse(token: ILoginResponse): void {
  sessionStore.setItem('token', JSON.stringify(token));
  try {
    const decoded = new JwtHelperService().decodeToken(token.accessToken);
    if (decoded?.id) {
      UmamiService.identify(decoded.id);
    }
  } catch (_) {}
}

export function setPermissions(permissions: Record<string, boolean>): void {
  sessionStore.setItem('permissions', JSON.stringify(permissions));
}

export function getPermissions(): Record<string, boolean>  {
  const permissions = sessionStore.getItem('permissions');
  return permissions ? JSON.parse(permissions) : {};
}
